import React from "react"
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks"
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import { IncidentCommentEditCommand } from "../../../../../services/varianceService/commands/IncidentCommentEditCommand";
import { useIncidentCommentEditMutation } from "../../../../../services/varianceService/variance-api";
import { toggleIncidentCommentEditModal } from "../../../../../app/slices/VarianceModuleSlice";
import { useMyProfileQuery } from "../../../../../services/profileService/profile-api";

function IncidentCommentEditDialog(){
    const dispatch = useAppDispatch();
    const { data } = useMyProfileQuery(); 
    const modalOpen = useAppSelector((state)=>state.varianceModule.IncidentCommentEditModal);
    const selectedComment = useAppSelector((state)=>state.varianceModule.SelectedCommentForEdit);
    const varianceId = useAppSelector((state)=>state.varianceRequest.varianceRequest.id);
    const [comment,setComment] = React.useState("");
    const [editComment] = useIncidentCommentEditMutation();

    React.useEffect(() => {
        if (selectedComment) {
            setComment(selectedComment.text || "");
        }
    }, [selectedComment]);
    
    const saveComment = ()=>{
        if (selectedComment) {
            let command = new IncidentCommentEditCommand(
                varianceId!,
                selectedComment.commentId.toString(),
                comment, 
                data!.identity!
            );
            editComment(command);
        }
    }

    const handleClose = () => {
        dispatch(toggleIncidentCommentEditModal(null));
        setComment('');
    }

    return <Dialog open={modalOpen} onClose={handleClose}>
        <DialogTitle>Edit Comment</DialogTitle>
        <DialogContent>
            <TextField 
                label='Comment' 
                value={comment} 
                onChange={(e)=>setComment(e.target.value)} 
                multiline 
                fullWidth
                sx={{width:'500px',marginTop:'10px'}} 
                minRows='3'
            />
        </DialogContent>
        <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button onClick={()=>{saveComment();handleClose();}}>Save</Button>
        </DialogActions>
    </Dialog>
}

export {IncidentCommentEditDialog}
